import { useState } from 'react';
import { Project } from '../../../types';
import { supabase } from '../../../lib/supabase';

export function useProjectDelete(project: Project, onDelete: () => void) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);

    try {
      // Delete project images from storage
      for (const image of project.images) {
        if (image.media_type === 'youtube') continue;
        
        const url = new URL(image.media_type === 'video' ? image.video_url! : image.url);
        const filePath = url.pathname.split('/').pop();
        if (filePath) {
          await supabase.storage
            .from('project-images')
            .remove([filePath]);
        }
      }

      // Delete project from database
      const { error: deleteError } = await supabase
        .from('projects')
        .delete()
        .eq('id', project.id);

      if (deleteError) throw deleteError;

      onDelete();
    } catch (err) {
      console.error('Error deleting project:', err);
      setError(err instanceof Error ? err.message : 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleDelete,
    setError
  };
}